import React from 'react';

const HeroSection = () => {
  return (
    <section style={{ position: 'relative', minHeight: '100vh', overflow: 'hidden', background: '#050A12' }}>
      {/* Background image */}
      <div style={{ position: 'absolute', inset: 0 }}>
        <img
          src="https://img.rocket.new/generatedImages/rocket_gen_img_152b04ea4-1772191888101.png"
          alt="Dramatic Norwegian mountain road winding through snow-capped peaks with fjord valley below at golden hour"
          style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center 30%', filter: 'brightness(0.35) contrast(1.2) saturate(0.8)' }} />
        
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg, rgba(5,10,18,0.9) 0%, rgba(5,10,18,0.4) 50%, rgba(5,10,18,0.85) 100%)' }} />
      </div>
      {/* Diagonal accent line */}
      <div style={{
        position: 'absolute',
        top: '20%',
        left: '-5%',
        width: '110%',
        height: '2px',
        background: 'linear-gradient(90deg, transparent, #3B6FD4, transparent)',
        transform: 'rotate(-3deg)',
        opacity: 0.6
      }} />
      {/* Content */}
      <div style={{
        position: 'relative',
        zIndex: 2,
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '180px 5% 120px',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '80px',
        alignItems: 'end'
      }}>
        <div>
          {/* Label */}
          <div style={{
            fontFamily: 'JetBrains Mono, monospace',
            fontSize: '0.6875rem',
            color: '#3B6FD4',
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            marginBottom: '24px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
            <div style={{ width: '32px', height: '1px', background: '#3B6FD4' }} />
            OM OSS
          </div>

          <h1 style={{
            fontFamily: 'Syne, sans-serif',
            fontSize: 'clamp(3rem, 7vw, 6rem)',
            fontWeight: 800,
            color: '#EEF0F2',
            letterSpacing: '-0.04em',
            lineHeight: 0.9,
            marginBottom: '32px',
            transform: 'rotate(-1deg)',
            transformOrigin: 'left center'
          }}>
            NORD-<br />
            <span style={{ color: '#3B6FD4' }}>PASS</span><br />
            STORY
          </h1>

          <p style={{
            fontFamily: 'Lora, serif',
            fontStyle: 'italic',
            fontSize: 'clamp(1rem, 1.5vw, 1.25rem)',
            color: 'rgba(238,240,242,0.7)',
            lineHeight: 1.7,
            maxWidth: '480px'
          }}>
            Grunnlagt i hjertet av Oslo, bygget for Norges veier. Vi er et team av norske ingeniører, kartografer og sjåfører som forstår hva det betyr å navigere dette landet.
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', paddingBottom: '20px' }}>
          {[
          { num: '2019', label: 'Grunnlagt' },
          { num: '47K+', label: 'Aktive brukere' },
          { num: '12', label: 'Teammedlemmer' },
          { num: '99.8%', label: 'Oppetid' }]?.
          map((stat, i) =>
          <div key={i} style={{
            display: 'flex',
            alignItems: 'center',
            gap: '20px',
            padding: '16px 20px',
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.06)',
            borderLeft: '3px solid #3B6FD4'
          }}>
              <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '1.75rem', fontWeight: 800, color: '#EEF0F2', letterSpacing: '-0.04em' }}>{stat?.num}</div>
              <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8125rem', color: 'rgba(138,149,163,0.8)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>{stat?.label}</div>
            </div>
          )}
        </div>
      </div>
      {/* Scroll indicator */}
      <div style={{
        position: 'absolute',
        bottom: '40px',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px'
      }}>
        <div style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.625rem', color: 'rgba(138,149,163,0.4)', letterSpacing: '0.15em' }}>SCROLL</div>
        <div style={{ width: '1px', height: '40px', background: 'linear-gradient(to bottom, rgba(59,111,212,0.6), transparent)' }} />
      </div>
    </section>);

};

export default HeroSection;